import $ from 'jquery';
import RevealWhenVisible from '../../components/reveal-when-visible';
import SingleProductColorSelect from './components/single-product-color-select';
import SingleProductSlider from '../../components/single-product-slider';
import SingleProductFullscreenSlider from '../../components/single-product-fullscreen-slider';
import StickyBar from '../../components/sticky-bar';
import ScrollTo from '../../components/scroll-to';
import CartPopup from './components/cart-popup';
import SingleProductForm from './components/single-product-form';
import QuantityInput from '../../components/quantity-input';
import HowProductWorks from './components/how-product-works';
import Timer from '../../components/timer';
import NewsSlider from '../discover-iqos/components/news-slider';
import BubblesSlider from '../../components/bubbles-slider';
import CustomizableBundleProducts from './components/customizable-bundle-products';
import ProductTradeIn from './components/product-trade-in';
import Collapse from '../../components/collapse';
import ScrollToByUrl from '../../core/components/scroll-to-by-url';
import RatingsAndReviews from './components/ratings-and-reviews';
import InlineVideo from '../../components/inline-video';
import ResponsiveVideo from '../../components/responsive-video';
import ModalVideoWithParameters from '../../components/modal-video-with-parameters';
import VariantStockForm from './components/variant-stock-form';
$(() => {
    RatingsAndReviews.init();
    VariantStockForm.init();
    SingleProductForm.init();
    SingleProductSlider.init();
    SingleProductFullscreenSlider.init();
    SingleProductColorSelect.init();
    CustomizableBundleProducts.init();
    ProductTradeIn.init();
    QuantityInput.init();
    CartPopup.init();
    RevealWhenVisible.init();
    HowProductWorks.init();
    Timer.init();
    ScrollTo.init();
    StickyBar.init();
    NewsSlider.init();
    BubblesSlider.init();
    Collapse.init();
    InlineVideo.init();
    ResponsiveVideo.init();
    setTimeout(() => {
        ScrollToByUrl.init();
    }, 0);
    ModalVideoWithParameters.init();
});
